import Vue from 'vue';

export default {
  getNewsDetail(id, guanWang) {
    return Vue.axios.get('/api/v1.0/system/news/detail?id=' + id + '&source=' + guanWang);
  }
};
